export default function () {
  return [
    {
      type: 'Input',
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '入党日期',
      [$field]: 'joinPartyDate',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '转正日期',
      [$field]: 'fullPartyDate',
      rules: ['']
    },
    {
      type: 'Input',
      title: '熟悉专业、有何专长',
      [$field]: 'userSpeciality',
      rules: ['']
    },
    // {
    //   type: 'SelectTree',
    //   title: '新社会阶层情况',
    //   [$field]: 'newSocialCondition',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM19',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // }, 
    // {
    //   type: 'SelectTree',
    //   title: '社会职称类型',
    //   [$field]: 'professionalDuty',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'GB8561',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '工作在一线情况',
    //   [$field]: 'frontWorkCondition',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'ZB86',
    //       merge: false
    //     }
    //   }
    // },
    {
      type: 'RemoteSelect',
      title: '档案管理单位是否为集团',
      [$field]: 'amdIsGroup',
      rules: [''],
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          bizLineCode: 'YWX01',
          merge: false
        }
      }
    },
    {
      type: 'Input',
      title: '档案管理单位',
      [$field]: 'archiveManagementDept',
      rules: ['']
    },
    {
      type: 'Input',
      title: '党龄',
      [$field]: 'partyStanding',
      rules: ['']
    },
    {
      type: 'Select',
      title: '党籍状态',
      [$field]: 'partyArchiveState',
      rules: [''],
      optionList: this.dictMap['BJ507']
    },
    {
      type: 'Input',
      title: '党内职务',
      [$field]: 'partyDuty',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '任党内职务开始时间',
      [$field]: 'expandFieldbc​',
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '组织关系隶属',
      [$field]: 'orgRelationSubjection',
      rules: [''],
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'BOE701',
          merge: false,
          bizLineCode: 'YWX01'
        }
      }
    }
    // {
    //   type: 'Select',
    //   title: '组织关系隶属',
    //   [$field]: 'orgRelationSubjection',
    //   rules: [''],
    //   optionList: this.dictMap['BOE701']
    // }
    // ,
    // {
    //   type: 'RemoteSelect',
    //   title: '是否失联党员',
    //   [$field]: 'isLostedPartyMember',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   }
    // },
    // {
    //   type: 'DatePicker',
    //   title: '联系日期',
    //   readOnly: true,
    //   [$field]: 'lostedLineDate',
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '是否流动党员',
    //   [$field]: 'isFloatPartyMember',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   }
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '是否在境外工作',
    //   [$field]: 'workOutside',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   }
    // }
  ]
}